{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Crash",
  "alternateName": [
    "краш кс го", "cs crash", "crash cs go", "краш на деньги",
    "cs2 crash", "сайт с крашем кс го", "crash csgo"
  ],
  "description": "Краш-игра, где множитель растет, а игроки должны вовремя забрать выигрыш.",
  "url": "https://6cs.fail/ru/crash"
}
